module.exports = "https://cdn.realtymogul.com/static/media/Hero_JVEquity.05ca64c9.jpg";